import { EventListener, RegistryInterface } from "silver";
import { Int32ArrayEncoder } from "shared/Int32ArrayEncoder";

const MAX_BOOKS = 100;

export class BookBagService {

	public readonly onModified = EventListener.create<{ bookIds: number[], previous: number[] }>("modified");

	constructor(
		private readonly storageKey: string,
		private readonly storage: RegistryInterface<string>,
		private readonly int32ArrayEncoder: Int32ArrayEncoder
	) { }

	public getBookIds(): number[] {
		const value = this.storage.get(this.storageKey);
		if (!value) {
			return [];
		}
		return this.int32ArrayEncoder.decode(value);
	}

	public setBookIds(bookIds: number[]): void {
		if (bookIds.length > MAX_BOOKS) {
			bookIds = bookIds.slice(-1 * MAX_BOOKS);
			console.warn(`Max books reached`);
		}
		const previous = this.getBookIds();
		const encoded = this.int32ArrayEncoder.encode(bookIds);
		this.storage.set(this.storageKey, encoded);
		this.onModified.trigger({ bookIds, previous });
	}

	public addBookIds(bookIds: number[]): void {
		this.setBookIds([...new Set([...bookIds, ...this.getBookIds()])]);
	}

	public removeBookIds(bookIds: number[]): void {
		const set = new Set(bookIds);
		this.setBookIds(this.getBookIds().filter(id => !set.has(id)));
	}

	public clear(): void {
		this.setBookIds([]);
	}
}
